import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import MetadataActions from 'invision-core/src/components/metadata/metadata.actions';
import MetadataConstants from 'invision-core/src/components/metadata/metadata.constants';
import MetadataSelectors from 'invision-core/src/components/metadata/metadata.selectors';
import i18n from 'invision-core/src/components/i18n/i18n';
import { debug } from 'invision-core/src/components/helpers/log.helper';
import pathOr from 'ramda/src/pathOr';
import CustomerCareLocaleKeys from '../../../../locales/keys';
import { CurrentCustomerSelector, HasConvergentBillerIdSelector } from '../../../../reducers/selectors/customer.selectors';
import { AddressesErrorSelector, CreateAddressPopupStateRegionProvinceValueOptions, IsCreatingAddressSelector, PostalCodeSelector, PreventOverrideFlagSelector } from '../../../../reducers/selectors/customer.addresses.selectors';
import { createAddress, setAddressData, updateOverrideFlag } from '../../../../reducers/actions/customer.addresses.actions';
import { ADDRESS_FORM_FIELD_MAX_LENGTH } from '../addresses.constants';
import { IsValidatingStatusSelector, UnvalidatedAddressesSelector, ValidatedAddressesSelector } from '../../../../reducers/selectors/address.component.selectors';
import { setForceShowEditFormAddress, validateAddress } from '../../../../reducers/actions/address.component.actions';
import { isAddressValidFromAddressResponse } from '../../../shared/contextualComponents/address/address.validator.helper';
import { performCreditCheck } from '../../../../reducers/actions/credit.check.actions';
import { stateRequiredHelper } from '../address.helper';
function CreateAddressPopupController($ngRedux, $timeout, uiNotificationService) {
  var _this = this;
  var disconnectRedux;
  var mapStateToTarget = function mapStateToTarget(store) {
    return {
      addressCountriesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.AddressCountry, store),
      addressRequirements: MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.AddressRequirements, store),
      addressRequirementsLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.AddressRequirements, store),
      addressStatesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.AddressStateProvinceRegion, store),
      addressStatesOptions: CreateAddressPopupStateRegionProvinceValueOptions(store),
      currentCustomer: CurrentCustomerSelector(store),
      hasConvergentBiller: HasConvergentBillerIdSelector(store),
      isCreatingAddress: IsCreatingAddressSelector(store),
      isDbss: IsDbss(store),
      isAddressBeingValidatedFromApi: IsValidatingStatusSelector(store),
      lastAttemptError: AddressesErrorSelector(store),
      postalCode: PostalCodeSelector(store),
      preventOverrideFlag: PreventOverrideFlagSelector(store),
      unvalidatedAddresses: UnvalidatedAddressesSelector(store),
      validatedAddresses: ValidatedAddressesSelector(store)
    };
  };
  var controllerActions = {
    createAddress: createAddress,
    fetchAddressCountryTypes: MetadataActions.codes.fetchAddressCountryTypes,
    fetchAddressStateTypes: MetadataActions.codes.fetchAddressStateTypes,
    fetchCodeType: MetadataActions.codes.fetchCodeTypes,
    performCreditCheck: performCreditCheck,
    setAddressData: setAddressData,
    setForceShowEditFormAddress: setForceShowEditFormAddress,
    updateOverrideFlag: updateOverrideFlag,
    validateAddress: validateAddress
  };
  var popupApi = null;
  var formFieldLocaleKeyMapping = {
    shipToName: CustomerCareLocaleKeys.ADDRESSES.SHIP_TO_NAME,
    textScrubber: CustomerCareLocaleKeys.ADDRESSES.TEXT_SCRUBBER,
    addressType: CustomerCareLocaleKeys.ADDRESSES.ADDRESS_TYPE
  };
  this.$onInit = function () {
    disconnectRedux = $ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
      _this.state = state;
      _this.actions = actions;
    });
    _this.resetForm = function () {
      _this.address = {
        Country: _this.state.currentCustomer.HomeCountry || null,
        State: null,
        DefaultPostal: _this.state.isDbss && !_this.state.hasConvergentBiller ? true : undefined,
        DefaultService: _this.state.isDbss && !_this.state.hasConvergentBiller ? true : undefined
      };
      _this.addressFormModel = {
        country: _this.address.Country,
        stateRegionProvince: _this.address.State
      };
      _this.textScrubberOverride = undefined;
      _this.formErrors = [];
      // called before $ngRedux.connect, must guard
      _this.actions && _this.state && _this.updateStateField();
    };
    _this.formMaxLengthValidation = ADDRESS_FORM_FIELD_MAX_LENGTH;
    _this.resetForm();
    _this.showForm = false;
    if (_this.state.postalCode.mask || _this.state.postalCode.regEx) {
      _this.actions.setAddressData(null);
    }
    if (!_this.state.addressStatesLoaded) {
      _this.actions.fetchAddressStateTypes();
    }
    if (!_this.state.addressRequirementsLoaded) {
      _this.actions.fetchCodeType(MetadataConstants.codes.AddressRequirements);
    }
    _this.CustomerCareLocaleKeys = CustomerCareLocaleKeys;
    _this.CoreLocaleKeys = CoreLocaleKeys;
    _this.formFieldLocaleKeyMapping = formFieldLocaleKeyMapping;
    _this.onAddressFormChanged = _this.onAddressFormChanged.bind(_this);

    // hook the popupApi
    var onRegisterApi = _this.config.onRegisterApi;
    _this.config.onRegisterApi = function (_ref) {
      var api = _ref.api;
      popupApi = Object.assign({}, api, {
        open: function open() {
          _this.resetForm();
          _this.showForm = true;
          // NOTE: must wait for the ng-if bound to showForm to operate, for the popup centering logic
          $timeout(function () {
            api.open();
          });
        }
      });
      onRegisterApi && onRegisterApi({
        api: popupApi
      });
    };
  };
  this.handleCloseDialog = function () {
    _this.closePopup();
  };
  this.handleKeypressForm = function (event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      _this.handleSubmitForm();
    }
  };
  this.handleSubmitForm = function () {
    _this.formController.$submitted = true;
    _this.formController.highlightErrorMessages();
    if (_this.formController.$valid) {
      _this.validateAddressWithAPI().then(function () {
        var addressKey = _this.getAddressKey();
        var validatedAddress = _this.state.validatedAddresses[addressKey];
        if (!addressKey || validatedAddress && isAddressValidFromAddressResponse(validatedAddress)) {
          _this.actions.createAddress(_this.customerId, validatedAddress.ValidatedAddress.Status ? validatedAddress.ValidatedAddress : _this.address, _this.textScrubberOverride, _this.state.preventOverrideFlag).then(function (result) {
            _this.closePopup();
            var onAddressCreated = _this.onAddressCreated();
            onAddressCreated && onAddressCreated(result.Address);
            _this.actions.performCreditCheck(null, _this.customerId);
            _this.actions.updateOverrideFlag(null);
          }, function () {
            _this.apiFaults = [_this.state.lastAttemptError.translatedMessage];
          });
        } else {
          _this.actions.setForceShowEditFormAddress(false);
          uiNotificationService.transientError(i18n.translate(_this.CustomerCareLocaleKeys.ADDRESS_COMPONENT.INVALID_ADDRESS_ERROR_MESSAGE));
        }
      }).catch(function (err) {
        uiNotificationService.transientError(err.translatedMessage);
      });
    }
  };
  this.handleClickCancelButton = function () {
    _this.closePopup();
  };
  this.handleChangeFormCountry = function () {
    _this.updateStateField();
  };
  this.closePopup = function () {
    if (_this.state.isCreatingAddress) {
      // app is going to crash; log a User-friendly message for the developer
      debug('closing popup while awaiting async operation');
    }
    popupApi.close();
    _this.showForm = false;
  };
  this.updateStateField = function () {
    _this.actions.setAddressData(_this.address, _this.textScrubberOverride);
    _this.stateRequired = stateRequiredHelper(_this.state.addressRequirements, _this.state.addressStatesOptions);

    // if Country has states, reset State if it's not one of them
    if (_this.state.addressStatesOptions && !_this.state.addressStatesOptions.find(function (stateOption) {
      return stateOption.value === _this.address.State;
    })) {
      _this.address.State = null;
      _this.addressFormModel.stateRegionProvince = _this.address.State;
    }
  };
  this.onAddressFormChanged = function (addressFormModel) {
    _this.address.LineOne = addressFormModel.addressLine1;
    _this.address.LineTwo = addressFormModel.addressLine2;
    _this.address.City = addressFormModel.city;
    _this.address.State = addressFormModel.stateRegionProvince;
    _this.address.PostalCode = addressFormModel.postalCode ? addressFormModel.postalCode : null;
    _this.address.ShipToName = addressFormModel.shipToName;
    _this.addressFormModel.addressLine1 = addressFormModel.addressLine1;
    _this.addressFormModel.addressLine2 = addressFormModel.addressLine2;
    _this.addressFormModel.city = addressFormModel.city;
    _this.addressFormModel.country = addressFormModel.country;
    _this.addressFormModel.stateRegionProvince = addressFormModel.stateRegionProvince;
    _this.addressFormModel.postalCode = addressFormModel.postalCode ? addressFormModel.postalCode : null;
    if (addressFormModel.country !== _this.address.country) {
      _this.address.Country = addressFormModel.country;
      _this.handleChangeFormCountry();
    }
  };
  this.$onDestroy = function () {
    disconnectRedux();
  };
  this.getAddressKey = function () {
    return pathOr(undefined, ['formController', 'addressWrapupController.singleAddressFormFormApi', 'addressKey'], _this);
  };
  this.getAddressKeyForAddressValidatedThroughAPI = function () {
    return pathOr(undefined, ['formController', 'addressWrapupController.singleAddressFormFormApi', 'keyForAddressValidatedThroughAPI'], _this);
  };
  this.getJobToken = function () {
    var addressKey = _this.getAddressKey(),
      addressKeyForAddressValidatedThroughAPI = _this.getAddressKeyForAddressValidatedThroughAPI(),
      validatedAddressForCurrentAddress = _this.state.validatedAddresses[addressKey],
      validatedAddressForAddressValidatedThroughAPI = _this.state.validatedAddresses[addressKeyForAddressValidatedThroughAPI];
    if (validatedAddressForCurrentAddress && validatedAddressForCurrentAddress.JobToken) {
      return validatedAddressForCurrentAddress.JobToken;
    } else if (validatedAddressForAddressValidatedThroughAPI && validatedAddressForAddressValidatedThroughAPI.JobToken) {
      return validatedAddressForAddressValidatedThroughAPI.JobToken;
    }
    return null;
  };
  this.validateAddressWithAPI = function () {
    var addressKey = _this.getAddressKey(),
      unvalidatedAddress = _this.state.unvalidatedAddresses[addressKey],
      validatedAddress = _this.state.validatedAddresses[addressKey];
    if (validatedAddress || !unvalidatedAddress) {
      return Promise.resolve(100);
    } else {
      var addressTypes = {
        DefaultBilling: _this.address.DefaultBilling,
        DefaultHome: _this.address.DefaultHome,
        DefaultPostal: _this.address.DefaultPostal,
        DefaultService: _this.address.DefaultService,
        DefaultShipping: _this.address.DefaultShipping,
        DefaultWork: _this.address.DefaultWork
      };
      return _this.actions.validateAddress(addressKey, unvalidatedAddress, _this.getJobToken(), addressTypes);
    }
  };
}
export default {
  template: require('./create.address.popup.html'),
  bindings: {
    config: '<',
    customerId: '<',
    onAddressCreated: '&',
    shipToNameRequired: '<'
  },
  controllerAs: 'CreateAddressPopupController',
  controller: CreateAddressPopupController
};